import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the widgetResume state domain
 */

const selectWidgetResumeDomain = (state) =>
  state.get("widgetResume", initialState)

/**
 * Other specific selectors
 */
export const makeSelectIsLoadingEvolutionMeasure = () =>
  createSelector(selectWidgetResumeDomain, (state) =>
    state.get("isLoadingEvolutionMeasure")
  )

export const makeSelectEvolutionData = () =>
  createSelector(selectWidgetResumeDomain, (state) =>
    state.get("evolutionData")
  )

export const makeSelectEvolutionLines = () =>
  createSelector(selectWidgetResumeDomain, (state) =>
    state.get("evolutionLines")
  )

const makeSelectWidgetResume = () =>
  createSelector(selectWidgetResumeDomain, (substate) => substate.toJS())

export default makeSelectWidgetResume
export { selectWidgetResumeDomain }
